import { useMemo } from 'react';
import { PricingFormInputOption } from '../../../../types';

export function useDelegateAdHocFormFreeTextInputOptions(
  options: PricingFormInputOption[],
) {
  return useMemo(() => {
    const freeTextOption = options.find((option) => option.freeText);

    // If the free text options filter array with it to render it separately
    const filteredOptions = freeTextOption
      ? options.filter((option) => !option.freeText)
      : options;

    return { freeTextOption, filteredOptions };
  }, [options]);
}
